export const defaultPieChartMargin = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

export const defaultPieChartColorRange = [
  "#00e680",
  "#000064",
  "#640064",
  "#ff0071",
  "#973dff",
  "#ff3700",
  "#91a4e4",
  "#640000",
  "#d9ead3",
  "#00e680",
];
